import { Pipe, PipeTransform } from '@angular/core';
import { O } from '@macs-frontend/core/utils/fp-ts';

@Pipe({ name: 'isNone', pure: true })
export class IsNonePipe implements PipeTransform {
  public transform(value: O.Option<unknown>): value is O.None {
    return O.isNone(value);
  }
}
